import React from 'react';

const Loader: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`loader-spinner ${className}`} style={{ display: 'inline-block', width: 20, height: 20 }}>
    <svg viewBox="0 0 50 50" style={{ width: '100%', height: '100%' }}>
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#888"
        strokeWidth="5"
        strokeDasharray="31.4 31.4"
        strokeLinecap="round"
        transform="rotate(-90 25 25)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </span>
);

export default Loader;
